import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-56f133dc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "product__img" }
const _hoisted_2 = { class: "slider" }
const _hoisted_3 = { class: "carousel__item--main" }
const _hoisted_4 = ["src"]
const _hoisted_5 = ["onClick"]
const _hoisted_6 = ["src"]

import { IProduct } from '@/services';
import { toRefs, reactive, ref, computed } from 'vue';
import 'vue3-carousel/dist/carousel.css';
import { Carousel, Slide } from 'vue3-carousel';
import { TIndexedImages } from './_types';


export default /*#__PURE__*/_defineComponent({
  __name: 'ProductImages',
  props: {
    product: null
  },
  setup(__props: any) {

const props = __props as {
  product: IProduct;
};



const { product } = reactive(props);
const { images } = toRefs(product);
const currentSlide = ref(Math.floor(images.value.length / 2));

const indexedImages = computed((): TIndexedImages[] => {
  return images.value.map((image, ind) => {
    return { id: ind, imgLink: image };
  });
});

const slideTo = (val: number) => {
  currentSlide.value = val;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      _createVNode(_unref(Carousel), {
        id: "gallery",
        "items-to-show": 1,
        "wrap-around": false,
        modelValue: currentSlide.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((currentSlide).value = $event))
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(indexedImages), (img) => {
            return (_openBlock(), _createBlock(_unref(Slide), {
              key: img.id
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("img", {
                    class: "slider__img--main",
                    src: img.imgLink,
                    alt: "product"
                  }, null, 8 /* PROPS */, _hoisted_4)
                ])
              ]),
              _: 2 /* DYNAMIC */
            }, 1024 /* DYNAMIC_SLOTS */))
          }), 128 /* KEYED_FRAGMENT */))
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["modelValue"]),
      _createVNode(_unref(Carousel), {
        id: "thumbnails",
        "items-to-show": 4,
        "wrap-around": false,
        modelValue: currentSlide.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((currentSlide).value = $event)),
        ref: "carousel"
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(indexedImages), (img) => {
            return (_openBlock(), _createBlock(_unref(Slide), {
              class: "slide",
              key: img.id
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", {
                  class: "carousel__item",
                  onClick: ($event: any) => (slideTo(img.id))
                }, [
                  _createElementVNode("img", {
                    class: "slider__img",
                    src: img.imgLink,
                    alt: "product"
                  }, null, 8 /* PROPS */, _hoisted_6)
                ], 8 /* PROPS */, _hoisted_5)
              ]),
              _: 2 /* DYNAMIC */
            }, 1024 /* DYNAMIC_SLOTS */))
          }), 128 /* KEYED_FRAGMENT */))
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["modelValue"])
    ])
  ]))
}
}

})